import React, { Component } from "react";
import _ from "lodash";
import Ajax from "Pub/js/ajax";
import { connect } from "react-redux";
import { Select } from "antd";
import HotKeysModal from "Components/HotKeysModal";
import Notice from "Components/Notice";
import { langCheck } from "Pub/js/utils";
import { getMulti } from "Pub/js/getMulti";
import platform from "Pub/js/platform";
import { queryOrgAuthority } from "./events";
import DataPermissionArea from './components/DataPermissionArea';
const { NCRadio } = platform.base;
const Option = Select.Option;
function MdcontentItem(props) {
    const { labelName, selectedValue, onChange } = props;
    return (
        <div className='mdcontentItem'>
            <span className='refer_label'>{labelName}</span>
            <NCRadio.NCRadioGroup selectedValue={selectedValue} onChange={onChange}>
                {props.children}
            </NCRadio.NCRadioGroup>
        </div>
    );
}
//参照模态框组件类
class ReferModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            pk_refinfo: "",
            refname: this.props.refname,
            showfocus: this.props.showfocus,
            iscode: this.props.iscode,
            onlyLeafCanSelect: this.props.onlyLeafCanSelect,
            isdatapowerenable: this.props.isdatapowerenable,
            //2111新增：是否启用组织权限
            isgrouppower: this.props.isgrouppower,
            isShowGroupPower: this.props.isShowGroupPower,
            option: [],
            json: {},
        };
        this.onOkDialog = this.onOkDialog.bind(this);
    }
    //ajax查询所有的参照
    componentWillReceiveProps(nextProps) {
        let { json } = this.state;
        if (nextProps.modalVisibel !== true) {
            return;
        } else {
            //弹框首次显示时
            if (nextProps.modalVisibel && !this.props.modalVisibel) {
                //组织权限false时查一下接口是否显示
                if (nextProps.refname && !nextProps.isShowGroupPower) {
                    this.setGroupPowerShow(nextProps.refname, nextProps.isgrouppower);
                }

                let dataval = this.props.dataval;
                let pk_refinfo = !_.isEmpty(dataval) ? dataval.split(",")[0] : "";
                const defaultfocus = this.getdefaultfocus(nextProps);
                this.setState({
                    pk_refinfo: pk_refinfo,
                    refname: nextProps.refname,
                    showfocus: nextProps.showfocus || defaultfocus,
                    iscode: nextProps.iscode,
                    onlyLeafCanSelect: nextProps.onlyLeafCanSelect || false,
                    isdatapowerenable: nextProps.isdatapowerenable || false,
                    datapoweroperationcode: nextProps.selectCard.datapoweroperationcode || '',
                    //2111新增：是否启用组织权限
                    isgrouppower: nextProps.isgrouppower || false,
                    isShowGroupPower: nextProps.isShowGroupPower || false,
                });
                let url, data;
                url = "/nccloud/platform/templet/queryrefinfo.do";
                data = {
                    defdoc: nextProps.selectCard && nextProps.selectCard.metaid,
                    isfilter: nextProps.areatype === '0', //查询区传true 过滤掉自定义档案
                };
                Ajax({
                    url: url,
                    data: data,
                    info: {
                        name: langCheck("ZoneSetting-000062", "pages", json) /* 国际化处理： 参照*/,
                        action: langCheck(
                            "ZoneSetting-000063",
                            "pages",
                            json,
                        ) /* 国际化处理： 查询参照*/,
                    },
                    success: ({ data }) => {
                        if (data.success && data.data) {
                            this.setState({ option: data.data });
                        } else {
                            Notice({ status: "error", msg: data.data.true });
                        }
                    },
                });

            }
        }
    }
	//设置参照模态框隐藏
	showModalHidden = () => {
	    this.props.setModalVisibel("referModalVisibel", false);
	};

	getdefaultfocus = (props = this.props) => {
	    return props.iscode ? (props.iscode === true ? "0" : "1") : "1";
	}
	asyncChange = (
	    refname,
	    pk_refinfo,
	    mycode,
	    showfocus,
	    onlyLeafCanSelect,
	    isdatapowerenable,
	    isgrouppower,
	    datapoweroperationcode,
	) => {
	    let { isShowSetting } = this.props;
	    const dataval = `${pk_refinfo},code=${mycode}`;
	    if (isShowSetting) {
	        this.props.handleSelectChange({
	            refname, //设置参照refname
	            dataval, // 设置参照名称
	            showfocus, // 设置showfocus
	            onlyLeafCanSelect, // 设置是否可以选择非叶子节点
	            isdatapowerenable,
	            isgrouppower,
	        });
	    } else {
	        //查询区参照只修改refname
	        this.props.handleSelectChange({
	            refname,
	            dataval,
	            datapoweroperationcode,
	            isdatapowerenable,
	        });
	    }
	};

	//保存验证
	validateSave = () => {
	    const { datapoweroperationcode, isdatapowerenable, json } = this.state;
	    //报表查询区选中启用数据权限必须选择使用场景
	    if (isdatapowerenable && !datapoweroperationcode) {
	        Notice({ status: "warning", msg: langCheck("ZoneSetting-000357", "pages", json) }); //使用场景不能为空
	        return false;
	    }
	    return true;
	}

	//确定
	async onOkDialog() {
	    if (!this.validateSave()) {return;}
	    let {
	        refname,
	        showfocus,
	        onlyLeafCanSelect,
	        pk_refinfo,
	        option,
	        json,
	        isdatapowerenable,
	        isgrouppower,
	        datapoweroperationcode,
	    } = this.state;
	    const mycode = showfocus;
	    const filterOption = _.filter(option, o => {
	        return o.pk_refinfo === pk_refinfo;
	    });
	    if (filterOption && filterOption.length && filterOption[0].refpath) {
	        await this.props.handleSelectChange(filterOption[0].refpath, "refcode");
	    }
	    this.props.onOk && this.props.onOk({ isShowGroupPower: this.state.isShowGroupPower });

	    this.asyncChange(
	        refname,
	        pk_refinfo,
	        mycode,
	        showfocus,
	        onlyLeafCanSelect,
	        isdatapowerenable,
	        isgrouppower,
	        datapoweroperationcode,
	    );
	    Ajax({
	        url: `/nccloud/platform/templet/getMetaByRefName.do`,
	        info: {
	            scode: langCheck("ZoneSetting-000064", "pages", json) /* 国际化处理： 关联元数据*/,
	            action: langCheck("ZoneSetting-000065", "pages", json) /* 国际化处理： 获取元数据数据*/,
	        },
	        data: {
	            showfocus: mycode ? mycode : "1",
	            onlyLeafCanSelect: onlyLeafCanSelect ? onlyLeafCanSelect : false,
	            refname: refname,
	        },
	        success: res => {
	            if (res) {
	                let { data, success } = res.data;
	                if (success && data) {
	                    // 设置元数据属性
	                    this.props.handleSelectChange(data, "metadataproperty");
	                }
	            }
	        },
	    });
	    this.showModalHidden();
	}
	//选择参照下拉切换
	handleSelectChange = (pk_refinfo, name) => {
	    this.setState({ pk_refinfo: pk_refinfo, refname: name });
	    //2111新增:是否启用组织权限
	    this.setGroupPowerShow(name);
	};

	//设置组织权限显隐
	setGroupPowerShow = (refname, isgrouppower = false) => {
	    queryOrgAuthority.call(this, refname, isShowGroupPower => {
	        this.setState({ isShowGroupPower },
	        () => {
	            this.setState({ isgrouppower });
	        },
	        );
	    });
	};

	//勾选设置showfocus
	checkboxChange = val => {
	    this.setState({ showfocus: val });
	};
	leafChange = val => {
	    this.setState({ onlyLeafCanSelect: val });
	};
	isDataPowerEnableChange = val => {
	    this.setState({ isdatapowerenable: val });
	};
	//2111新增：是否开启组织权限
	isGroupPowerChange = val => {
	    this.setState({ isgrouppower: val });
	}
	handleStateChange = (key, val) => {
	    this.setState({ [key]: val });
	}
	componentDidMount() {
	    //多语
	    let callback = json => {
	        this.setState({ json: json });
	    };
	    getMulti({
	        moduleId: "ZoneSetting",
	        domainName: "workbench",
	        callback,
	    });
	}
	render() {
	    let { showfocus, iscode, onlyLeafCanSelect, option, refname, json, isdatapowerenable, isgrouppower, isShowGroupPower, datapoweroperationcode } = this.state;
	    const defaultfocus = this.getdefaultfocus();
	    return (
	        <div className='myZoneModal'>
	            <HotKeysModal
	                customHeader={langCheck(
	                    "ZoneSetting-000066",
	                    "pages",
	                    json,
	                )} /* 国际化处理： 参照类型设置*/
	                wrapClassName='zonesetting-referModal'
	                visible={this.props.modalVisibel}
	                okText={langCheck("ZoneSetting-000005", "pages", json)} /* 国际化处理： 确定*/
	                cancelText={langCheck(
	                    "ZoneSetting-000006",
	                    "pages",
	                    json,
	                )} /* 国际化处理： 取消*/
	                onOk={this.onOkDialog}
	                destroyOnClose={true}
	                onCancel={this.showModalHidden}
	                fieldid='referType'>
	                <div style={{ margin: 20 }}>
	                    {
	                        this.props.isShowSetting && (
	                            <div className='descrip_label'>
	                                {langCheck("ZoneSetting-000067", "pages", json)}{" "}
	                            </div>
	                        )
	                    }
	                    {/* /* 国际化处理： 参照设置*/}
	                    <div className='mdcontent'>
	                        <div className='mdcontentItem'>
	                            <span className='refer_label'>
	                                {langCheck("ZoneSetting-000068", "pages", json)}
	                            </span>
	                            {/* /* 国际化处理： 参照选择:*/}
	                            <Select
	                                showSearch
	                                optionFilterProp='children'
	                                filterOption={(input, option) =>
	                                    option.props.children
	                                        .toLowerCase()
	                                        .indexOf(input.toLowerCase()) >=
										0
	                                }
	                                value={refname}
	                                onChange={(value, optionObj) => {
	                                    this.handleSelectChange(
	                                        value,
	                                        optionObj.props.children,
	                                    );
	                                }}
	                                style={{ width: 220 }}
	                                notFoundContent={langCheck("ZoneSetting-000278", "pages", json)}
	                            >
	                                {option.map((c, index) => {
	                                    return (
	                                        <Option
	                                            key={index}
	                                            value={c.pk_refinfo}
	                                            title={c.name}
	                                        >
	                                            {c.name}
	                                        </Option>
	                                    );
	                                })}
	                            </Select>
	                        </div>
	                    </div>
	                </div>
	                {
	                    this.props.isShowSetting && (
	                        <div style={{ margin: 20 }}>
	                            <div className='descrip_label'>
	                                {langCheck("ZoneSetting-000069", "pages", json)}{" "}
	                            </div>
	                            {/* /* 国际化处理： 关联设置*/}
	                            <div className='mdcontent'>
	                                <MdcontentItem
	                                    labelName={langCheck(
	                                        "ZoneSetting-000070",
	                                        "pages",
	                                        json,
	                                    )}
	                                    selectedValue={showfocus || defaultfocus}
	                                    onChange={this.checkboxChange}>
	                                    <NCRadio value='0'>
	                                        {langCheck("ZoneSetting-000081", "pages", json)}
	                                    </NCRadio>
	                                    <NCRadio value='1'>
	                                        {langCheck("ZoneSetting-000131", "pages", json)}
	                                    </NCRadio>
	                                    <NCRadio value='2'>
	                                        {langCheck("ZoneSetting-000243", "pages", json)}
	                                    </NCRadio>
	                                </MdcontentItem>
	                                <MdcontentItem
	                                    labelName={langCheck(
	                                        "ZoneSetting-000232",
	                                        "pages",
	                                        json,
	                                    )}
	                                    selectedValue={onlyLeafCanSelect || false}
	                                    onChange={this.leafChange}>
	                                    <NCRadio value={true}>
	                                        {langCheck("ZoneSetting-000229", "pages", json)}
	                                    </NCRadio>
	                                    <NCRadio value={false}>
	                                        {langCheck("ZoneSetting-000230", "pages", json)}
	                                    </NCRadio>
	                                </MdcontentItem>
	                                {/* <MdcontentItem
										// 是否启用数据权限
										labelName={langCheck(
											"ZoneSetting-000327",
											"pages",
											json
										)}
										selectedValue={isdatapowerenable}
										onChange={this.isDataPowerEnableChange}>
										<NCRadio value={true}>
											{langCheck("ZoneSetting-000229", "pages", json)}
										</NCRadio>
										<NCRadio value={false}>
											{langCheck("ZoneSetting-000230", "pages", json)}
										</NCRadio>
									</MdcontentItem> */}
	                                {/* 2111新增：是否启用组织权限 */}
	                                {isShowGroupPower &&
										<MdcontentItem
										    labelName={langCheck(
										        "ZoneSetting-000340",
										        "pages",
										        json,
										    )}
										    selectedValue={isgrouppower}
										    onChange={this.isGroupPowerChange}
										>
										    <NCRadio value={true}>
										        {langCheck("ZoneSetting-000229", "pages", json)}
										    </NCRadio>
										    <NCRadio value={false}>
										        {langCheck("ZoneSetting-000230", "pages", json)}
										    </NCRadio>
										</MdcontentItem>
	                                }
	                            </div>
	                        </div>
	                    )
	                }
	                {/* 报表查询区非元数据显示数据权限 */}
	                {this.props.isreport && !this.props.selectCard.metapath && (
	                    <div style={{ margin: 20 }}>
	                        <DataPermissionArea
	                            dataSource={{
	                                isdatapowerenable,
	                                datapoweroperationcode,
	                            }}
	                            referData={{
	                                pk_refinfo: this.state.pk_refinfo,
	                                pk: this.state.pk_refinfo, //多传一个pk
	                            }}
	                            json={json}
	                            onDataPowerEnableChange={this.handleStateChange.bind(this, 'isdatapowerenable')}
	                            onUsedSceneChange={this.handleStateChange.bind(this, 'datapoweroperationcode')}
	                        />
	                    </div>
	                )}
	            </HotKeysModal>
	        </div>
	    );
	}
}
export default connect(
    state => ({
        selectCard: state.zoneSettingData.selectCard,
        areaList: state.zoneSettingData.areaList,
        isreport: state.zoneSettingData.isreport,
    }),
    {},
)(ReferModal);
